// Fake values to tooltip. It will be replaced by resource from database.
// Structure
// {
//   key: '',
//   provinces: [''],
//   languages: [''],
//   level: [''],
//   value: ""
// },
// TODO: Get all tips from server
const tooltips = [
  // -- Start of Alberta - Elementary --
  {
    key: 'Alt. French',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "Percentage of students registered in French Immersion programs."
  },
  {
    key: 'Gr 3 avg test mark: Lang. Arts',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "This is the average test mark percentage by all of the school’s students for Grade 3. Blank info indicates no data currently available."
  },
  {
    key: 'Gr 3 avg test mark Lang. Arts',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "This is the average test mark percentage by all of the school’s students for Grade 3. Blank info indicates no data currently available."
  },
  {
    key: 'Gr 3 avg test mark',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "This is the average test mark percentage by all of the school’s students for Grade 3. Blank info indicates no data currently available."
  },
  {
    key: 'Gr 3 avg test mark: Math',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "This is the average test mark percentage by all of the school’s students for Grade 3. Blank info indicates no data currently available."
  },
  {
    key: 'Gr 6 Enrolment',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "The number of students enrolled in Grade 6 for the most recent year."
  },
  {
    key: 'Gr 6 avg test mark: Lang. Arts',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "This is the average test mark percentage by all of the school's students on the grade 6 Provincial Achievement Tests in language arts, mathematics, science, and social studies."
  },
  {
    key: 'Gr 6 avg test mark',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "This is the average test mark percentage by all of the school's students on the grade 6 Provincial Achievement Tests in language arts, mathematics, science, and social studies."
  },
  {
    key: 'Gr 6 avg test mark: Math',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "This is the average test mark percentage by all of the school's students on the grade 6 Provincial Achievement Tests in language arts, mathematics, science, and social studies."
  },
  {
    key: 'Gr 6 avg test mark: Science',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "This is the average test mark percentage by all of the school's students on the grade 6 Provincial Achievement Tests in language arts, mathematics, science, and social studies."
  },
  {
    key: 'Gr 6 avg test mark: Social Studies',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "This is the average test mark percentage by all of the school's students on the grade 6 Provincial Achievement Tests in language arts, mathematics, science, and social studies."
  },
  {
    key: 'Gr 6 gender gap: Lang. Arts',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator measures the difference (in percentage points), if any, between boys and girls in their average marks on the achievement tests in grade 6 language arts and mathematics.  The indicator reports the more successful gender and the size of the difference, F=Female, M=Male, E=No difference"
  },
  {
    key: 'Gr 6 gender gap: Math',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator measures the difference (in percentage points), if any, between boys and girls in their average marks on the achievement tests in grade 6 language arts and mathematics.  The indicator reports the more successful gender and the size of the difference, F=Female, M=Male, E=No difference"
  },
  {
    key: 'Gr 6 gender gap',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator measures the difference (in percentage points), if any, between boys and girls in their average marks on the achievement tests in grade 6 language arts and mathematics.  The indicator reports the more successful gender and the size of the difference, F=Female, M=Male, E=No difference"
  },
  {
    key: 'Percentage of tests failed',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator provides the rate of failure (as a percentage) on the achievement tests."
  },
  {
    key: 'Alt. French %',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary'],
    value: "Percentage of students registered in French Immersion programs."
  },
  // -- End of Alberta - Elementary --

  // -- Start of Alberta - Secondary --
  {
    key: 'Alt. French',
    provinces: ['ab'],
    languages: ['en'],
    level: ['secondary'],
    value: "Percentage of students enrolled in French immersion or other alternative programs in French. Does not include those enrolled in Francophone programs or in regular French courses."
  },
  {
    key: 'Alt. French %',
    provinces: ['ab'],
    languages: ['en'],
    level: ['secondary'],
    value: "Percentage of students enrolled in French immersion or other alternative programs in French. Does not include those enrolled in Francophone programs or in regular French courses."
  },
  {
    key: 'Average exam mark',
    provinces: ['ab'],
    languages: ['en'],
    level: ['secondary'],
    value: "The average exam mark (as a percentage) achieved by the students on all of the school’s grade-12 diploma examinations."
  },
  {
    key: 'Percentage of exams failed',
    provinces: ['ab'],
    languages: ['en'],
    level: ['secondary'],
    value: "The percentage of all the diploma exams written by the students at the school that received a grade below 50%."
  },
  {
    key: 'Language Arts gender gap',
    provinces: ['ab'],
    languages: ['en'],
    level: ['secondary'],
    value: "The difference (in percentage points), if any, between boys’ and girls’ average exam marks in Language Arts and Mathematics. The indicator reports the more successful gender and size of the difference. F=Female, M=Male, E=No difference"
  },
  {
    key: 'Math gender gap',
    provinces: ['ab'],
    languages: ['en'],
    level: ['secondary'],
    value: "The difference (in percentage points), if any, between boys’ and girls’ average exam marks in Language Arts and Mathematics. The indicator reports the more successful gender and size of the difference. F=Female, M=Male, E=No difference"
  },
  {
    key: 'Courses taken per student',
    provinces: ['ab'],
    languages: ['en'],
    level: ['secondary'],
    value: "The average number of diploma courses by those students at the school who have completed their 3 years of high school. The 2022 calculation is paused as the January 2022 diploma exam administration was canceled due to the COVID-19 context. The 2023 calculation is revised."
  },
  {
    key: 'Diploma completion rate',
    provinces: ['ab'],
    languages: ['en'],
    level: ['secondary'],
    value: "The percentage of students, enrolled in grade 12 for the first time, who received a diploma in the same school year."
  },
  // -- End of Alberta - Secondary --

  // -- Start of British Columbia - Elementary --
  {
    key: 'ESL %',
    provinces: ['ab', 'on'],
    languages: ['en'],
    level: ['elementary', 'secondary'],
    value: "Percentage of students for whom English is a second-language."
  },
  {
    key: 'ESL %',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary', 'secondary'],
    value: "Share of students identified as English Language Learning (ELL) students, those that need additional English language development support."
  },
  {
    key: 'Special Needs %',
    provinces: ['ab', 'bc', 'on'],
    languages: ['en'],
    level: ['elementary'],
    value: "Percentage of students with Special Needs."
  },
  {
    key: 'Gr 4 Enrolment',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "The number of students enrolled in Grade 4 for the most recent year."
  },
  {
    key: 'French Immersion %',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary', 'secondary'],
    value: "Percentage of students registered in French Immersion programs."
  },
  {
    key: 'Gr 4 avg score',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator shows how well each school's students performed, compared to students in all other schools, on the uniform Foundation Skills Assessments (FSAs) in reading, writing, literacy and numeracy in grade-4. In the 2021/22 school year, the BC government replaced the Reading and Writing FSAs with a Literacy FSA as part of changes to align with the new curriculum."
  },
  {
    key: 'Gr 4 avg score: Reading',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator shows how well each school’s students performed, compared to students in all other schools, on the uniform Foundation Skills Assessments (FSAs) in reading, writing, literacy and numeracy in grade-4. In 2021/2022 the BC government replaced the reading and writing FSAs with a literacy FSA as part of changes to align with the new curriculum."
  },
  {
    key: 'Gr 4 avg score: Writing',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator shows how well each school’s students performed, compared to students in all other schools, on the uniform Foundation Skills Assessments (FSAs) in reading, writing, literacy and numeracy in grade-4. In 2021/2022 the BC government replaced the reading and writing FSAs with a literacy FSA as part of changes to align with the new curriculum."
  },
  {
    key: 'Gr 4 avg score: Literacy',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator shows how well each school’s students performed, compared to students in all other schools, on the uniform Foundation Skills Assessments (FSAs) in reading, writing, literacy and numeracy in grade-4. In 2021/2022 the BC government replaced the reading and writing FSAs with a literacy FSA as part of changes to align with the new curriculum."
  },
  {
    key: 'Gr 4 avg score: Numeracy',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary', 'secondary'],
    value: "This indicator shows how well each school’s students performed, compared to students in all other schools, on the uniform Foundation Skills Assessments (FSAs) in reading, writing, literacy and numeracy in grade-4. In 2021/2022 the BC government replaced the reading and writing FSAs with a literacy FSA as part of changes to align with the new curriculum."
  },
  {
    key: 'Gr 7 avg score',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator shows how well each school's students performed, compared to students in all other schools, on the uniform Foundation Skills Assessments (FSAs) in reading, writing, literacy and numeracy in Grade-7. In the 2021/22 school year, the BC government replaced the Reading and Writing FSAs with a Literacy FSA as part of changes to align with the new curriculum."
  },
  {
    key: 'Gr 7 avg score: Reading',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator shows how well each school’s students performed, compared to students in all other schools, on the uniform Foundation Skills Assessments (FSAs) in reading, writing, literacy, and numeracy in grade-7. In 2021/2022 the BC government replaced the reading and writing FSAs with a literacy FSA as part of changes to align with the new curriculum."
  },
  {
    key: 'Gr 7 avg score: Writing',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator shows how well each school’s students performed, compared to students in all other schools, on the uniform Foundation Skills Assessments (FSAs) in reading, writing, literacy, and numeracy in grade-7. In 2021/2022 the BC government replaced the reading and writing FSAs with a literacy FSA as part of changes to align with the new curriculum."
  },{
    key: 'Gr 7 avg score: Literacy',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator shows how well each school’s students performed, compared to students in all other schools, on the uniform Foundation Skills Assessments (FSAs) in reading, writing, literacy, and numeracy in grade-7. In 2021/2022 the BC government replaced the reading and writing FSAs with a literacy FSA as part of changes to align with the new curriculum."
  },
  {
    key: 'Gr 7 avg score: Numeracy',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator shows how well each school’s students performed, compared to students in all other schools, on the uniform Foundation Skills Assessments (FSAs) in reading, writing, literacy, and numeracy in grade-7. In 2021/2022 the BC government replaced the reading and writing FSAs with a literacy FSA as part of changes to align with the new curriculum."
  },
  {
    key: 'Gr 7 gender gap',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator measures the difference (in percentage points), if any, between boys and girls in their average marks on the achievement tests in grade 7 reading, literacy and numeracy. The indicator reports the more successful gender and the size of the difference, F=Female, M=Male, E=No difference. In 2021/2022 the BC government replaced the reading FSAs with a literacy FSA as part of changes to align with the new curriculum."
  },
  {
    key: 'Gr 7 gender gap: Reading',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator measures the difference (in percentage points), if any, between boys and girls in their average marks on the achievement tests in grade 7 reading, literacy and numeracy. The indicator reports the more successful gender and the size of the difference, F=Female, M=Male, E=No difference. In 2021/2022 the BC government replaced the reading FSAs with a literacy FSA as part of changes to align with the new curriculum."
  },
  {
    key: 'Gr 7 gender gap: Literacy',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator measures the difference (in percentage points), if any, between boys and girls in their average marks on the achievement tests in grade 7 reading, literacy and numeracy. The indicator reports the more successful gender and the size of the difference, F=Female, M=Male, E=No difference. In 2021/2022 the BC government replaced the reading FSAs with a literacy FSA as part of changes to align with the new curriculum."
  },
  {
    key: 'Gr 7 gender gap: Numeracy',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator measures the difference (in percentage points), if any, between boys and girls in their average marks on the achievement tests in grade 7 reading, literacy and numeracy. The indicator reports the more successful gender and the size of the difference, F=Female, M=Male, E=No difference. In 2021/2022 the BC government replaced the reading FSAs with a literacy FSA as part of changes to align with the new curriculum."
  },
  {
    key: 'Below expectations (%)',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "The percentage of all completed tests written by the school’s students that did not meet provincial expectations."
  },
  {
    key: 'Tests not written (%)',
    provinces: ['bc'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator measures the total number of FSA tests that could have been written by students at the school but which, for whatever reason, were not written."
  },
  // -- End of British Columbia - Elementary --

  // -- Start of British Columbia - Secondary --
  {
    key: 'Special Needs %',
    provinces: ['ab', 'bc', 'on'],
    languages: ['en'],
    level: ['secondary'],
    value: "Percentage of students with special needs."
  },
  {
    key: 'Average exam mark',
    provinces: ['bc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The average provincial mark achieved by the school's students in all the grade-10, grade-11, and grade-12 courses in which the provincial exam is mandatory."
  },
  {
    key: 'Percentage of exams failed',
    provinces: ['bc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The percentage of all the mandatory grade-10, grade-11, and grade-12 provincial exams written by students at the school that received a failing grade."
  },
  {
    key: 'English gender gap',
    provinces: ['bc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The difference (in percentage points), if any, between boys’ and girls’ average exam marks in English. The indicator reports the more successful gender and size of the difference. F=Female, M=Male, E=No difference."
  },
  {
    key: 'Math gender gap',
    provinces: ['bc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The difference (in percentage points), if any, between boys’ and girls’ average exam marks in Math. The indicator reports the more successful gender and size of the difference. F=Female, M=Male, E=No difference."
  },
  {
    key: 'Gr 12 Enrolment',
    provinces: ['ab', 'bc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The number of students enrolled in Grade 12 for the most recent year."
  },
  {
    key: 'Gender Gap (English, Math)',
    provinces: ['bc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The difference (in percentage points), if any, between boys’ and girls’ average exam marks in English and Math. The indicator reports the more successful gender and size of the difference. F=Female, M=Male, E=No difference"
  },
  {
    key: 'Graduation rate',
    provinces: ['bc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The percentage of students, enrolled in grade 12 for the first time, who received a diploma in the same school year."
  },
  {
    key: 'Delayed advancement rate',
    provinces: ['bc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The estimated percentage of the school's grade-10 students who are not likely to complete grade 12 within the normal three-year period."
  },
  // -- End of British Columbia - Secondary --

  // -- Start of Ontario - Elementary --
  {
    key: 'ESL (%)',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "Percentage of students for whom English is a second-language."
  },
  {
    key: 'Special Needs (%)',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "Percentage of students with Special Needs."
  },

  {
    key: 'Gr 6 Enrolment',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "The number of students enrolled in Grade 6 for the most recent year."

  },
  {
    key: 'Gr 3 avg. level',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "These indicators show the average level of proficiency achieved by the school's students on the uniform EQAO assessments in reading, writing, and mathematics in grade-3.  The EQAO converts the raw score on each test into a level of achievement from 1 to 4.  Levels 1 and 2 = not met provincial standard.  Level 3 = met provincial standard, and Level 4 = above provincial standard."
  },
  {
    key: 'Gr 3 avg. level: Reading',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "These indicators show the average level of proficiency achieved by the school's students on the uniform EQAO assessments in reading, writing, and mathematics in grade-3.  The EQAO converts the raw score on each test into a level of achievement from 1 to 4.  Levels 1 and 2 = not met provincial standard.  Level 3 = met provincial standard, and Level 4 = above provincial standard."
  },
  {
    key: 'Gr 3 avg. level: Writing',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "These indicators show the average level of proficiency achieved by the school's students on the uniform EQAO assessments in reading, writing, and mathematics in grade-3.  The EQAO converts the raw score on each test into a level of achievement from 1 to 4.  Levels 1 and 2 = not met provincial standard.  Level 3 = met provincial standard, and Level 4 = above provincial standard."
  },
  {
    key: 'Gr 3 avg. level: Math',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "These indicators show the average level of proficiency achieved by the school's students on the uniform EQAO assessments in reading, writing, and mathematics in grade-3.  The EQAO converts the raw score on each test into a level of achievement from 1 to 4.  Levels 1 and 2 = not met provincial standard.  Level 3 = met provincial standard, and Level 4 = above provincial standard."
  },
  {
    key: 'Gr 6 avg. level',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "These indicators show the average level of proficiency achieved by the school's students on the uniform EQAO assessments in reading, writing, and mathematics in grade-6.  The EQAO converts the raw score on each test into a Level of achievement from 1 to 4.  Levels 1 and 2 = not met provincial standard.  Level 3 = met provincial standard, and Level 4 = above provincial standard."
  },
  {
    key: 'Gr 6 avg. level: Reading',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "These indicators show the average level of proficiency achieved by the school's students on the uniform EQAO assessments in reading, writing, and mathematics in grade-6.  The EQAO converts the raw score on each test into a Level of achievement from 1 to 4.  Levels 1 and 2 = not met provincial standard.  Level 3 = met provincial standard, and Level 4 = above provincial standard."
  },
  {
    key: 'Gr 6 avg. level: Writing',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "These indicators show the average level of proficiency achieved by the school's students on the uniform EQAO assessments in reading, writing, and mathematics in grade-6.  The EQAO converts the raw score on each test into a Level of achievement from 1 to 4.  Levels 1 and 2 = not met provincial standard.  Level 3 = met provincial standard, and Level 4 = above provincial standard."
  },
  {
    key: 'Gr 6 avg. level: Math',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "These indicators show the average level of proficiency achieved by the school's students on the uniform EQAO assessments in reading, writing, and mathematics in grade-6.  The EQAO converts the raw score on each test into a Level of achievement from 1 to 4.  Levels 1 and 2 = not met provincial standard.  Level 3 = met provincial standard, and Level 4 = above provincial standard."
  },
  {
    key: 'Gender gap (level)',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary', 'secondary'],
    value: "This indicator uses the grade-6 results of the EQAO's assessments to measure the difference (in percentage points), if any, between boys and girls in their average marks on the achievement tests in grade 6 reading and math.  The indicator reports the more successful gender and the size of the difference, F=Female, M=Male, E=No difference"
  },
  {
    key: 'Gender gap (level): Reading',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator uses the grade-6 results of the EQAO's assessments to measure the difference (in percentage points), if any, between boys and girls in their average marks on the achievement tests in grade 6 reading and math.  The indicator reports the more successful gender and the size of the difference, F=Female, M=Male, E=No difference"
  },
  {
    key: 'Gender gap (level): Math',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator uses the grade-6 results of the EQAO's assessments to measure the difference (in percentage points), if any, between boys and girls in their average marks on the achievement tests in grade 6 reading and math.  The indicator reports the more successful gender and the size of the difference, F=Female, M=Male, E=No difference"
  },
  {
    key: 'Tests below standard (%)',
    provinces: ['on'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator provides the rate of failure (as a percentage) to meet the provincial standard on the EQAO tests."
  },
  {
    key: 'Tests not written (%)',
    provinces: ['ab', 'on'],
    languages: ['en'],
    level: ['elementary'],
    value: "This indicator measures the total number of tests that could have been written by students at the school but which, for whatever reason, were not written."
  },
  // -- End of Ontario - Elementary --

  // -- Start of Ontario - Secondary --
  {
    key: 'Avg. level Gr 9 Math (Acad)',
    provinces: ['on'],
    languages: ['en'],
    level: ['secondary'],
    value: "This indicator shows the average level of proficiency achieved by the school's students on the grade-9 uniform assessments in Math (Academic). The EQAO converts the raw score on each test into a level of achievement from 1 to 4.  Levels 1 and 2 = not met provincial standard.  Level 3 = met provincial standard, and Level 4 = above provincial standard.<br /><span class='font-w-bold'>*A new de-streamed math course replaced the Grade 9 academic and applied math courses in 2021/22.</span>"
  },
  {
    key: 'Avg. level Gr 9 Math (Apld)',
    provinces: ['on'],
    languages: ['en'],
    level: ['secondary'],
    value: "This indicator shows the average level of proficiency achieved by the school's students on the grade-9 uniform assessments in Math (Apld). The EQAO converts the raw score on each test into a level of achievement from 1 to 4.  Levels 1 and 2 = not met provincial standard.  Level 3 = met provincial standard, and Level 4 = above provincial standard.<br /><span class='font-w-bold'>*A new de-streamed math course replaced the Grade 9 academic and applied math courses in 2021/22.</span>"
  },
  {
    key: 'OSSLT passed (%)-FTE',
    provinces: ['on'],
    languages: ['en'],
    level: ['secondary'],
    value: "The percentage of eligible OSSLT (Ontario Secondary School Literacy Test) who successfully completed the test. FTE=First attempt in grade 10, PE=Subsequent attempt"
  },
  {
    key: 'OSSLT passed (%)-PE',
    provinces: ['on'],
    languages: ['en'],
    level: ['secondary'],
    value: "The percentage of eligible OSSLT (Ontario Secondary School Literacy Test) who successfully completed the test. FTE=First attempt in grade 10, PE=Subsequent attempt"
  },
  {
    key: 'Tests below standard (%)',
    provinces: ['on'],
    languages: ['en'],
    level: ['secondary'],
    value: "This indicator combines the results of all the OSSLT and grade-9 mathematics tests written by the students at the school, and reports the percentage of tests that were below standards."
  },
  {
    key: 'Gender gap (level)-Math',
    provinces: ['on'],
    languages: ['en'],
    level: ['secondary'],
    value: "This indicator calculates the absolute value of the difference, if any, between male and female students in their average level of achievement in grade-9 mathematics.  The indicator reports the more successful gender and size of the difference. F=Female, M=Male, E=No difference"
  },
  {
    key: 'Gr 9 tests not written (%)',
    provinces: ['on'],
    languages: ['en'],
    level: ['secondary'],
    value: "This indicator reports the percentage of grade-9 mathematics tests that could have been written by students at the school but which, for whatever reason, were not written."
  },
  {
    key: 'OSSLT Count',
    provinces: ['on'],
    languages: ['en'],
    level: ['secondary'],
    value: "The number of students at the school who were eligible to write the OSSLT for the most recent year.",
  },
  // -- End of Ontario - Secondary --

  // -- Start of Québec - Secondary --
  {
    key: "Overestimate by School (%)",
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: "This indicator shows the failure rate (inPercentage points by which the average of school grades in the five subjects exceeds the average of the results in the uniform tests."
  },
  {
    key: "Surestimation par l'école (%)",
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: "Points de pourcentage par lesquels la moyenne des notes obtenues à l’école dans les cinq matières dépasse la moyenne des résultats aux épreuves uniformes."
  },
  {
    key: "Gender difference (%): Language",
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The difference (in percentage points), if any, between boys’ and girls’ average exam marks in Language Arts and Mathematics. The indicator reports the more successful gender and size of the difference. F=Female, M=Male, E=No difference"
  },
  {
    key: "Écart sexes (%): Langue d'ens.",
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: "La différence (en points de pourcentage), le cas échéant, entre les notes d'examen moyennes des garçons et des filles en arts du langage et en mathématiques. L'indicateur indique le sexe et la taille de la difference"
  },
  {
    key: "Gender difference (%)",
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The difference (in percentage points), if any, between boys’ and girls’ average exam marks in Language Arts and Mathematics. The indicator reports the more successful gender and size of the difference. F=Female, M=Male, E=No difference"
  },
  {
    key: "Écart sexes (%)",
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: "La différence (en points de pourcentage), le cas échéant, entre les notes d'examen moyennes des garçons et des filles en arts du langage et en mathématiques. L'indicateur indique le sexe et la taille de la difference"
  },
  {
    key: "Progression – Rate of Delay (%)",
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The proportion of students who have not completed high school in the expected time."
  },
  {
    key: "Progression - taux de retard (%)",
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: "La proportion des élèves qui n’ont pas terminé leurs études secondaires dans le temps prévu."
  },
  {
    key: "Overall Rating (out of 10)",
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The overall rating reflects the performance of all students in the school across all indicators. It answers the following question: \"In general, how does the school succeed compared to all the other schools in the Bulletin?\""
  },
  {
    key: "Cote globale (sur 10)",
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: "La cote globale tient compte de la performance de tous les élèves de l’école sur le plan de l’ensemble des indicateurs. Elle répond à la question suivante : « En général, comment l’école réussit-elle par rapport à l’ensemble des autres écoles figurant dans le Bulletin? »"
  },
  {
    key: "Language of instruction (%)",
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The average marks achieved by the school’s students in the primary Language of instruction administered in Secondary V."
  },
  {
    key: "Langue d'enseignement (%)",
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: "La moyenne des notes obtenues par les élèves de l’école dans la première langue d’enseignement dispensée en secondaire V."
  },
  {
    key: "Second Language (%)",
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The average marks achieved by the school’s students the Second language of instruction administered in Secondary V."
  },
  {
    key: "Langue seconde (%)",
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: "La note moyenne obtenue par les élèves de l’école est la deuxième langue d’enseignement dispensée en secondaire V."
  },
  {
    key: "History and Citizenship Education (%)",
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The average marks achieved by the school’s students in the History and Citizenship examinations administered in Secondary IV."
  },
  {
    key: "Histoire et éducation à la citoyenneté (%)",
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: "La note moyenne obtenue par les élèves de l’école aux examens d’histoire et de citoyenneté administrés en 4e secondaire."
  },
  {
    key: "Science and Technology (%)",
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The average marks achieved by the school’s students in the Science and Technology examinations administered in Secondary IV."
  },
  {
    key: "Science et technologie (%)",
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: "La moyenne des notes obtenues par les élèves de l’école aux examens de sciences et technologies du secondaire IV."
  },
  {
    key: "Mathematics (%)",
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The average marks achieved by the school’s students in the Math examinations administered in Secondary IV."
  },
  {
    key: "Mathématiques (%)",
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: "La moyenne des notes obtenues par les élèves de l’école aux examens de mathématiques de la 4e secondaire."
  },
  {
    key: 'Marquer',
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: 'Il s\'agit d\'une note globale sur 10, basée sur les indicateurs mesurés.'
  },
  {
    key: 'Cote globale',
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: 'Il s\'agit d\'une note globale sur 10, basée sur les indicateurs mesurés.'
  },
  {
    key: 'Rang',
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: 'Le rendement scolaire de l\'école se classe par rapport aux autres écoles de la province.'
  },
  {
    key: 'Number of Students',
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: 'The number of students enrolled in the school for the most recent year.'
  },
  {
    key: "Nombre d'élèves",
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: 'Le nombre d\'élèves inscrits à l\'école pour l\'année la plus récente.'
  },
  {
    key: 'Academic Delay (%)',
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: 'Indicates the proportion of students who are 16 years of age or older at the beginning of Secondary IV, which is the percentage of older students than most of their classmates.'
  },
  {
    key: 'En retard (%)',
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: 'Indique la proportion d’élèves ayant 16 ans ou plus en début de 4e secondaire, soit le pourcentage d’élèves plus âgés que la plupart de leurs camarades de classe.'
  },
  {
    key: 'Special Needs (%)',
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: "Indicates the proportion of students in Secondary IV and V considered \"handicapped or in difficulty of adaptation and learning\" and for whom public schools receive additional funding."
  },
  {
    key: 'EHDAA (%)',
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: "Indique la proportion d’élèves de 4e et de 5e secondaire considérés comme « handicapés ou en difficulté d’adaptation et d’apprentissage » et pour lesquels les écoles publiques reçoivent un financement supplémentaire."
  },
  {
    key: 'Failure Rate (%)',
    provinces: ['qc'],
    languages: ['en'],
    level: ['secondary'],
    value: "This indicator shows the failure rate (in %) in the five subjects measured."
  },
  {
    key: 'Échec (%)',
    provinces: ['qc'],
    languages: ['fr'],
    level: ['secondary'],
    value: "Cet indicateur présente le taux d’échec (en %) dans les cinq sujets mesurés."
  },
  // -- End of Québec - Secondary --

  // -- Start of Multiple --
  {
    key: 'Add to Compare',
    provinces: ['bc', 'ab', 'on', 'qc'],
    languages: ['en', 'fr'],
    level: ['elementary', 'secondary'],
    value: 'Compare rankings of up to six schools.'
  },
  {
    key: 'Notify Me',
    provinces: ['bc', 'ab', 'on', 'qc'],
    languages: ['en'],
    level: ['elementary', 'secondary'],
    value: 'Please send me an email when the next Provincial Report Card is released.'
  },
  {
    key: 'Prévenez-moi',
    provinces: ['bc', 'ab', 'on', 'qc'],
    languages: ['fr'],
    level: ['elementary', 'secondary'],
    value: 'Please send me an email when the next Provincial Report Card is released.'
  },
  {
    key: 'Overall rating out of 10',
    provinces: ['bc', 'ab', 'on', 'qc'],
    languages: ['en'],
    level: ['elementary', 'secondary'],
    value: 'The overall rating reflects the performance of all students in the school across all indicators. It answers the following question: "In general, how does the school succeed compared to all the other schools in the Bulletin?"'
  },
  {
    key: 'Score',
    provinces: ['bc', 'ab', 'on', 'qc'],
    languages: ['en'],
    level: ['elementary', 'secondary'],
    value: 'This is an overall rating out of 10, based on the measured indicators.'
  },
  {
    key: 'Rank',
    provinces: ['bc', 'ab', 'on', 'qc'],
    languages: ['en'],
    level: ['elementary', 'secondary'],
    value: 'How the school’s academic performance ranks compared to the other schools in the province.'
  },
  {
    key: 'School vs exam mark difference',
    provinces: ['ab', 'bc'],
    languages: ['en'],
    level: ['secondary'],
    value: "The difference (in percentage points) between the average exam mark for the “school”, and the average  exam mark provincially. Where the provincial exam marks are higher, the result is set to zero."
  },
  {
    key: 'Delayed advancement rate',
    provinces: ['bc'],
    languages: ['en'],
    level: ['secondary'],
    value: "This indicator measures the extent to which schools keep their students in school and progressing in a timely manner towards completion of their graduation program.  This indicator calculates a statistic that will answer the questions \"Based on this single year's school results, what is the likelihood that a student entering grade 10 at the school will graduate in the normal three-year period?\""
  },
  {
    key: 'Delayed advancement rate',
    provinces: ['ab'],
    languages: ['en'],
    level: ['elementary', 'secondary'],
    value: "The estimated percentage of the school’s grade-10 students who are not likely to complete grade 12 within the normal three-year period."
  },
  {
    key: 'Gender gap OSSLT',
    provinces: ['bc', 'ab', 'on', 'qc'],
    languages: ['en'],
    level: ['secondary'],
    value: "This indicator calculates the absolute value of the difference, if any, between male and female students in their average level of achievement in the OSSLT. The indicator reports the more sucessful gender and size of the difference. F=Female, M-Male, E-No difference."
  },
  // -- End of Multiple --
];

export default {

  // TODO: Use repository to get tooltip
  getTooltipByName(tooltipName, province, level, language) {
    let result;
    result = tooltips.find((tooltip) => {
      return (
        tooltip.key.toLowerCase().trim().replace('  ', ' ') == tooltipName.toLowerCase().trim().replace('  ', ' ')
        && (province != undefined ? tooltip.provinces.includes(province.toLowerCase().trim()) : true)
        && (level != undefined ? tooltip.level.includes(level.toLowerCase().trim()) : true)
        && (language != undefined ? tooltip.languages.includes(language.toLowerCase().trim()) : true));
    });
    return result != undefined ? result.value : null;
  }
}
